export function extractVideoFrame(video: HTMLVideoElement, time?: number): string | null {
  try {
    if (time !== undefined && !Number.isNaN(time) && Number.isFinite(time)) {
      video.currentTime = time;
    }

    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth || video.clientWidth;
    canvas.height = video.videoHeight || video.clientHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/png');
  } catch (e) {
    console.error('提取视频帧失败', e);
    return null;
  }
}
